// styles
import { COLORS } from 'shared/styles/base';

// constants
import { BOTTOM_NAV_STATE } from 'shared/store/app/types';
import { MEGA_MENU_V2 } from 'shared/constants/uri';
import { MY_ACCOUNT } from 'shared/constants/uri';
import { IExtraBNConfig } from './types';

export const BOTTOM_NAV_HEIGHT = 56;

export const BOTTOM_NAV_COLORS = {
  DEFAULT_STATE: COLORS.BLACK_64,
  SELECTED_STATE: COLORS.BRAND_PRIMARY_100,
};

export interface IBottomNavState {
  name: string;
  id: BOTTOM_NAV_STATE;
  url: string;
  icon?: string;
  selectedIcon?: string;
  image?: string;
  selectedImage?: string;
}

// TODO: move url to constants after my account and shop is done
export const BOTTOM_NAV_STATES: IBottomNavState[] = [
  {
    name: 'Home',
    icon: 'icon-bn-home',
    id: BOTTOM_NAV_STATE.HOME,
    selectedIcon: 'icon-bn-home',
    url: '/',
  },
  {
    name: 'Categories',
    image: 'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/bn-shop.svg',
    selectedImage:
      'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/bn-shop-filled.svg',
    id: BOTTOM_NAV_STATE.SHOP,
    url: MEGA_MENU_V2,
  },
  {
    name: 'Account',
    icon: 'icon-bn-account',
    selectedIcon: 'icon-bn-account-filled',
    id: BOTTOM_NAV_STATE.MY_ACCOUNT,
    url: MY_ACCOUNT,
  },
];

export const getBottomNavConfig = (extraConfig: IExtraBNConfig) => {
  if (extraConfig.enabled === true) {
    return [
      ...BOTTOM_NAV_STATES.slice(0, extraConfig.position),
      extraConfig,
      ...BOTTOM_NAV_STATES.slice(extraConfig.position),
    ];
  }

  return BOTTOM_NAV_STATES;
};
